<template>
  <div v-if="reservation">
    <o-panel-link
      v-if="order"
      :path="`/order/${order.idOrder}`"
      class="block p-2 border rounded-md hover:bg-gray-50 transition-colors duration-200 dark:border-gray-800 dark:bg-gray-800/50"
    >
      <div class="flex justify-between items-center flex-grow leading-none">
        <div class="leading-none">
          <p class="mb-1">
            #{{ order.orderNumber }}
          </p>
          <p class="text-xs opacity-70">
            {{ order.dateLabel }}
          </p>
        </div>

        <div class="flex items-center">
          <div class="flex items-center space-x-2">
            <o-chip v-if="isPaid" variant="success" flat>
              {{ $t('general.paid') }}
            </o-chip>
            <o-chip :variant="variant" flat>
              {{ order.statusLabel || '-' }}
            </o-chip>
          </div>
          <p class="ml-4 text-sm font-semibold">
            {{ order.priceLabel }}
          </p>
        </div>
      </div>
    </o-panel-link>

    <div v-if="!order && !isPaid">
      <o-button icon="sale" flat :loading="loading" @click="handleCreateOrder">
        {{ $t('order.new') }}
      </o-button>
    </div>
  </div>
</template>

<script setup lang="ts">

interface Props {
  reservation: Record<string, any>
}

const props = defineProps<Props>()

const loading = ref(false)

const { createOrder } = useOrderCreate()

const order = computed(() => props.reservation.order)
const isPaid = computed(() => props.reservation.isPaid)

const variant = computed(() => {
  const status = order.value.statusLabel

  switch (status) {
    case 'Open':
      return 'warning'
    case 'Closed':
      return 'success'
    default:
      return 'info'
  }
})

async function handleCreateOrder () {
  loading.value = true

  const customer = props.reservation.customer
  const items = [props.reservation]

  const data = {
    customer,
    items,
  }

  await createOrder(data)

  loading.value = false
}
</script>
